import React from 'react';

const CompletedBox = (props) => {
  return (
    <h2 className="box-title">{props.day}</h2>
  )
}

export default CompletedBox;